import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    projectDatas: ''
  },
  mutations: {
    updateProjectDatas (state, newDatas) {
      state.projectDatas = newDatas
    }
  },
  actions: {
  },
  modules: {
  }
})
